export const parseId = (id: string): number => {
  try {
    const idAtob = window.atob(id)
    return Number(idAtob.split(':')[1]) || 0
  } catch (error) {
    return 0
  }
}
